/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */

export const CONSTANTS = {
  thumbnail: "thumbnail",
  name: "name",
  orderItemInventoryStatus: "orderItemInventoryStatus",
  quantity: "quantity",
  categoryBook: "categoryBook",
  orderItemPrice: "orderItemPrice",
  orderItemActions: "orderItemActions",
};
